const Position = (cell) => {
    return cell.value ? cell.value : '';
};

const Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Email = (cell) => {
    return cell.value ? cell.value : '';
};
const Phone = cell => {
  return cell.value ? cell.value : ""
}
const IsActive = cell => {
  return cell.value ? cell.value : ""
}



export { Position, Email, Name, Phone, IsActive }